import { getAdminList } from '@/services/user/UserController';
import { useRequest } from 'ahooks';

export default function AdminModel() {
  /**获取用户列表*/
  const getAdminListReq = useRequest(getAdminList, {
    manual: true,
  });

  return {
    getAdminListReq,
  };
}
